import { RiLogoutCircleRLine, RiHome4Line, RiFileChartLine } from "react-icons/ri";
import { BsQuestionCircleFill, BsQuestionSquare } from "react-icons/bs";
import { PiBookOpenText } from "react-icons/pi";
import { SiGoogleclassroom } from "react-icons/si";
import { HiOutlineClipboardList } from "react-icons/hi";
import { MdOutlineQuiz, MdOutlineVideoCameraFront, MdVideoLibrary } from "react-icons/md";
import { FiUsers } from "react-icons/fi";
import { FaList } from "react-icons/fa";
import { icons } from "react-icons/lib";

// Sidebar Items
const SyllabusSidebarItems = [
    // {
    //     icon: RiHome4Line,
    //     heading: "Dashboard",
    // },
    // {
    //     icon: FaList,
    //     heading: 'Topics'
    // },
    {
        icon: MdOutlineQuiz,
        heading: 'questions'
    },

    {
        icon: MdOutlineVideoCameraFront,
        heading: 'lectures'
    },
    // {
    //     icon: BsQuestionSquare,
    //     heading: 'Doubts'
    // },
    {
        icon: PiBookOpenText,
        heading: 'readings'
    },
    {
        icon: MdVideoLibrary,
        heading: 'videos'
    },
    // {
    //     icon: HiOutlineClipboardList,
    //     heading: "Quizzes",
    // },
    // {
    //     icon: UilPackage,
    //     heading: 'Products'
    // },


    // {
    //     icon: FiUsers,
    //     heading: "Personal",
    // },
];

export default SyllabusSidebarItems;